export default (store) => ({
  layout: { fluid: true },
  path : '/kitchens/:kitchenSlug/schedule-ranges(/:tab)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'ScheduleRanges' */
      './components/ScheduleRanges'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
